/* eslint-disable no-unused-vars */
import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
// import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import axios from "axios";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import ReactLoading from "react-loading";
import PropTypes from "prop-types";
import RTL from "layouts/rtl";

export default function EditUserSuccess({ name1, email1, password1, phone1, roleid1 }) {
  EditUserSuccess.propTypes = {
    name1: PropTypes.string.isRequired,
    email1: PropTypes.string.isRequired,
    password1: PropTypes.string.isRequired,
    phone1: PropTypes.string.isRequired,
    roleid1: PropTypes.string.isRequired,
  };
  const route = useLocation().pathname.split("/").slice(1);
  const [dialogsucesss, setOpen1] = React.useState(false);
  const [dialogloading, setOpen3] = React.useState(false);
  const handleClickOpenLoading = () => {
    setOpen3(true);
  };
  const handleCloseLoading = () => {
    setOpen3(false);
  };
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleClickOpenSuccess = () => {
    setOpen1(true);
  };

  const handleCloseSuccess = () => {
    setOpen1(false);
  };

  function editUser() {
    console.log("selectedFile");
    // console.log(selectedFile);
    const token = sessionStorage.getItem("token");
    const headers = { Authorization: `Bearer ${token}`, ContentType: `application/json` };
    axios
      .post(
        "https://trust-cargo.co/anas_backend/api/edit_user",
        {
          id: route[route.length - 1],
          name: name1,
          email: email1,
          password: password1,
          role_id: roleid1,
          mobile: phone1,
        },
        { headers }
      )
      .then((response) => {
        handleClickOpenSuccess();
        // navigate(`/users`);
      })
      .catch((error) => {
        console.log(error);
      });
  }
  return (
    <div>
      <Button
        variant="contained"
        style={{ margin: "20px" }}
        onClick={() => {
          handleClickOpenLoading();
          editUser();
        }}
      >
        {t("save")}
      </Button>
      <Dialog
        open={dialogsucesss}
        onClose={handleCloseSuccess}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">تم تعديل المستخدم بنجاح</DialogTitle>
        <DialogContent>
          {/* <DialogContentText id="alert-dialog-description">
            Let Google help apps determine location. This means sending anonymous location data to
            Google, even when no apps are running.
          </DialogContentText> */}
        </DialogContent>
        <DialogActions>
          {/* <Button onClick={handleClose}>ok</Button> */}
          <Button
            onClick={() => {
              navigate(`/users`);
            }}
            autoFocus
          >
            {t("ok")}
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={dialogloading}
        onClose={handleCloseLoading}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <ReactLoading color="blue" height={50} width={50} type="spokes" />
      </Dialog>
    </div>
  );
}
